/**
 * Created by Zyy.
 * User: zouyingyang@qq.com
 * Date: 2019/3/13
 * Time: 11:39
 * Desc:
 */

/**
 * @desc 获取cookie
 * @param name cookie的key
 * @returns {string}
 */
export const getCookie = (name) => {
  var arr = document.cookie.split("; ");
  for (let i = 0; i < arr.length; i++) {
    const arr2 = arr[i].split("=");
    if (arr2[0] === name) {
      return arr2[1];
    }
  }
  return "";
};

/**
 * 设置cookie
 * @param name cookie的key
 * @param value cookie的value
 * @param expiredays 设置过期时间
 * @param domain 所在域
 * @param path 路径
 */
export const setCookie = (name, value, expiredays, domain, path) => {
  let exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie =
    name +
    "=" +
    escape(value) +
    (expiredays == null ? "" : ";expires=" + exdate.toGMTString()) +
    (domain ? "; domain=" + domain : "") +
    (path ? "; path=" + path : "");
};
// export const setCookie=(name, value, expires, path, domain, secure)=>{
//     var cookieText = encodeURIComponent(name) + '=' + encodeURIComponent(value);
//     if (expires instanceof Date) {
//         cookieText += '; expires=' + expires;
//     }
//     if (path) {
//         cookieText += '; expires=' + expires;
//     }
//     if (domain) {
//         cookieText += '; domain=' + domain;
//     }
//     if (secure) {
//         cookieText += '; secure';
//     }
//     // 添加cookie的原生方法
//     document.cookie = cookieText;
// }

/**
 * @desc 删除cookie
 * @param name cooie的key
 */
export const delCookie = (name) => {
  let exp = new Date();
  exp.setTime(exp.getTime() - 1);
  let cval = getCookie(name);
  console.log(cval, name, "00000");
  if (cval != null) {
    // document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString()
    console.log(document.cookie, "00000");
  }
};

/**
 * @desc 获取url参数
 * @param {String} name  想要获取的参数名字
 */
export const getQueryString = (name) => {
  const hash = window.location.hash;
  if( hash && hash.indexOf("?") > -1) {
    const queryString = hash.split("?")[1];
    const params = new URLSearchParams(queryString);
    return params.get(name);
  }
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
};

export const getQueryParam = (paramName) => {
  const urlObj = new URL(window.location.href);
  const paramValue = urlObj.searchParams.get(paramName);
  return decodeURIComponent(paramValue);
};



// WEBPACK FOOTER //
// ./src/util/extends/cookieExpand.js